import React from 'react'
import './HelpNearYou1.css'
// import './HelpNearYou.css'

const HelpNearYouHead = () => {
  return (
    <div className="helpNearYouHeadContainer">
    <div className="helpNearYouHeadContent">
      <h5>Discover a Salon Near You</h5>
      <div className="helpNearYouUnderline"></div>
    </div>
  </div>
  )
}

export default HelpNearYouHead
